
import styled from "styled-components";

export const Poster=styled.img`
width:100%;

`;

export const Poster1=styled.img`
width:10%;
position: absolute;
margin-left: -1px;
top: 400px;
`;

export const Limited=styled.h1`
text-align  : center;
margin: 15px 0px 15px 0px;
font-size:4vh ;
`;

export const MainGrid=styled.div`
width: 85%;
margin: auto;
  display:flex;
  flex-direction:row;
  
`;

export const Grid=styled.div`
  flex: 1;
  margin: 10px 0px 0px 10px;
  height: 200px;
  width: 200px;
`;

export const Poster2=styled.img`
width: 95%;
height: 500px;
margin:2%;

`;

export const Poster3=styled.img`
width:85%;
position: absolute;
padding:4% 0% 0% 3%;
`;


export const MainGrid2=styled.div`
display: grid;
grid-template-columns: repeat(6,195px);
grid-template-rows: repeat(2,200px);
gap: 2%;
margin:2% 1.5% 0% 2%;
`;

export const Poster4=styled.img`
width: 95%;
height: 500px;
margin:2%;
border: 1px solid blue;
`;

export const MainGrid3=styled.div`
 display: flex;
 width: 95%;
 gap: 1%;
 margin: 2%;

`;

export const Triplet=styled.div`
   width:90%;
   margin: 15% 5% 0% 5%;
`;

export const Flex=styled.div`
   display:flex;
   width: 95%;
   margin: auto;
   background-color:rgb(238, 238, 238);
`;

export const MainGrid4=styled.div`
   display: grid;
   grid-template-columns:repeat(3,1fr);
   width:95%;
   margin: auto;
   
`;

export const Hori=styled.hr`
color: lightgrey;
margin: 2% 0% 2% 0%;

`;

